// src/api/semesterService.js
import apiClient from "./apiClient";

// 🔹 Get all semesters (optionally filtered with params)
export const getSemesters = async (params = {}) => {
  const response = await apiClient.get("/semesters/", { params });
  return response.data;
};

// 🔹 Get semester by ID
export const getSemesterById = async (id) => {
  const response = await apiClient.get(`/semesters/${id}`);
  return response.data;
};

// 🔹 Create a new semester
export const createSemester = async (data) => {
  const response = await apiClient.post("/semesters/", data);
  return response.data;
};

// 🔹 Update a semester
export const updateSemester = async (id, data) => {
  const response = await apiClient.put(`/semesters/${id}`, data);
  return response.data;
};

// 🔹 Delete a semester
export const deleteSemester = async (id) => {
  const response = await apiClient.delete(`/semesters/${id}`);
  return response.data;
};

// ✅ Correct version — Get semesters belonging to a specific program
export const getSemestersByProgram = async (programId) => {
  const response = await apiClient.get(`/semesters/by_program/${programId}`);
  return response.data;
};
